class CenterActiveCategory {
	constructor(selector = '.woocommerce-categories') {
		this.container = document.querySelector(selector);
		if (this.container) this.center();
	}

	center() {
		const active = this.container.querySelector('.is-active');
		if (active) {
			this.container.scrollLeft = active.offsetLeft + active.offsetWidth / 2 - this.container.clientWidth / 2;
		}
	}
}

document.addEventListener('DOMContentLoaded', () => new CenterActiveCategory());